import { useState } from 'react'
import clsx from 'clsx'

import { Button } from '@/ui/Button'
import { Popup } from '@/ui/Popup'
import { Checkbox } from '@/ui/Checkbox'

import styles from './RoutesFilter.module.scss'

import FilterIcon from '../assets/filter.svg'
import { Input } from '@/ui/Input'

interface Props {
    selectedValues: string[]
    availableRoutes: string[]
    onChange: (routes: string[]) => void
}

export const RoutesFilter = ({ availableRoutes, selectedValues, onChange }: Props) => {
    const [search, setSearch] = useState('')

    const buttonLabel = selectedValues.length ? `Filtered (${selectedValues.length})` : 'Filter routes'
    const options = availableRoutes.reduce<{ label: string; value: string }[]>(
        (acc, route) => (route.includes(search) ? [...acc, { label: route, value: route }] : acc),
        []
    )

    const selectRoute = (route: string) => {
        let updatedValues = [...selectedValues]

        if (selectedValues.includes(route)) {
            updatedValues = updatedValues.filter((item) => item !== route)
        } else {
            updatedValues.push(route)
        }

        onChange(updatedValues)
    }

    const clearValues = () => {
        onChange([])
    }

    const checkIsRowSelected = (route: string) => selectedValues.includes(route)

    return (
        <Popup
            triggerComponent={
                <Button
                    rounded
                    variant="secondary"
                    size="small"
                    className={styles.trigger}
                    disabled={!availableRoutes.length}
                >
                    <FilterIcon />
                    {buttonLabel}
                </Button>
            }
            attachToTrigger
            placement="bottom-start"
            className={styles.popup}
        >
            <div className={styles.container}>
                <div className={styles.searchInputWrapper}>
                    <Input
                        placeholder="Type to search for route"
                        value={search}
                        fullWidth
                        variant="large"
                        allowClear
                        onChange={(event) => setSearch(event.target.value)}
                    />
                </div>
                <div className={styles.scrollContainer}>
                    <div className={styles.optionsWrapper}>
                        <div className={styles.optionsActions}>
                            <p className={styles.selectedLabel}>{selectedValues.length} selected</p>
                            <button
                                className={clsx(styles.clear, {
                                    [styles.clearActive]: !!selectedValues.length,
                                })}
                                onClick={clearValues}
                            >
                                Clear
                            </button>
                        </div>
                        {options.map(({ label, value }) => (
                            <Button
                                key={value}
                                size="small"
                                variant="transparent"
                                onClick={() => selectRoute(value)}
                                className={styles.item}
                            >
                                <span>{label}</span>
                                <Checkbox variant="withoutLabel" checked={checkIsRowSelected(value)} />
                            </Button>
                        ))}
                    </div>
                </div>
            </div>
        </Popup>
    )
}
